export const TRANSLATION_LANGUAGES = [
  { id: 'zh_CN', label: '中文' },
  { id: 'zh_TW', label: '繁体中文' },
  { id: 'ru', label: '俄语' },
  { id: 'en', label: '英语' },
  { id: 'ja', label: '日语' },
  { id: 'ko', label: '韩语' },
  { id: 'fr', label: '法语' },
  { id: 'de', label: '德语' },
  { id: 'es', label: '西班牙语' },
  { id: 'pt', label: '葡萄牙语' },
  { id: 'it', label: '意大利语' },
  { id: 'ar', label: '阿拉伯语' },
  { id: 'th', label: '泰语' },
  { id: 'vi', label: '越南语' },
  { id: 'id', label: '印尼语' },
  { id: 'ms', label: '马来语' },
  { id: 'tr', label: '土耳其语' },
  { id: 'pl', label: '波兰语' },
  { id: 'nl', label: '荷兰语' },
  { id: 'uk', label: '乌克兰语' },
];

export const getTranslationLanguageLabel = languageId => {
  return (
    TRANSLATION_LANGUAGES.find(language => language.id === languageId)?.label ||
    languageId
  );
};
